import React from "react"
import { 
  MagnifyingGlassIcon, 
  ChevronDownIcon,
  EyeIcon
} from "@heroicons/react/24/outline";

const reports = [
    {
        id: 1,
        fullName: "Salman Ali",
        username: "Salman615",
        mobile: "12324242423",
        date:"03/80/2023",
        reason: "Policy Violation"
    }

  ]
  
  export default function AllReports() {
    return (
      <div className="bg-white rounded-[10px] border border-dashboardStroke shadow-[0px_9px_15px_rgba(0,0,0,0.07)] overflow-hidden">
        {/* Dark Header */}
        <div className="bg-dashboardDark h-16 px-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h2 className="text-white font-semibold text-lg">Reports</h2>
            <span className="text-white font-semibold">({reports.length})</span>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 px-3 py-1.5 border border-white rounded">
              <MagnifyingGlassIcon className="w-[18px] h-[18px] text-white" />
              <input
                type="text"
                placeholder="Type to search..."
                className="bg-transparent text-white placeholder-white/70 text-sm font-light outline-none w-28"
              />
            </div>
            
            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>Sort By</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>
            
            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>Date Range</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-dashboardStroke">
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Sr#</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Full Name</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">User Name</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Mobile #</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Date/Time</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">Reason</th>
                <th className="px-4 py-4 text-left text-[17px] font-medium text-dashboardText">Actions</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((report, index) => (
                <tr 
                  key={report.id}
                  className={`border-b border-dashboardStroke hover:bg-gray-50 transition-colors ${
                    index === 0 ? "shadow-[inset_3px_0px_0px_#FF7C17]" : ""
                  }`}
                >
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {report.id}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {report.fullName}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-medium text-dashboardCoral">
                    {report.username}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {report.mobile}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {report.date}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {report.reason}
                  </td>
                  <td className="px-4 py-4">
                    <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                      <EyeIcon className="w-6 h-6 text-dashboardDark" strokeWidth={1.3} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
  